const MODULE_NAME = 'JobsModule';

export const GET_CURRENT_JOB = `${MODULE_NAME}/GET_CURRENT_JOB`;
export const GET_JOBS = `${MODULE_NAME}/GET_JOBS`;
export const GET_JOB_PROGRESS_TASKS = `${MODULE_NAME}/GET_JOB_PROGRESS_TASKS`;
